import type { Sort } from '@ztechapps/common.contract'
import type { Search, SearchTypeEnum } from '../types/QueryInput'
export enum StorageType {
  localStorage = 'localStorage',
  sessionStorage = 'sessionStorage',
  none = 'none',
}
export type ListActionOptions<T = any> = {
  defaultSort?: Sort<T>
  defaultSearch?: Search
  defaultFilterCascade?: boolean
  defaultSearchType?: SearchTypeEnum
  timeZone?: string
  storageKey?: string
  storageType?: StorageType
}
